// extracted by mini-css-extract-plugin
export default {"photoPanel":"PhotoPanel_photoPanel__wCI2Q"};